<template>
  <div>
    <loader :isVisible="$store.state.isLoading"></loader>
    
    <router-view></router-view>
        
    <notifications group="custom-info" position="top right">
      <template slot="body" slot-scope="props">
        <div class="alert alert-primary mb-2">
        <a class="close" @click="props.close"><i class="icon-cross"></i></a>
        <strong>{{props.item.title}}</strong>
        <br>{{props.item.text}}
      </div>
      </template>
    </notifications>

    <notifications group="custom-success" position="top right">
      <template slot="body" slot-scope="props">
        <div class="alert alert-success">
        <a class="close" @click="props.close"><i class="icon-cross"></i></a>
        <strong>{{props.item.title}}</strong>
        <br>{{props.item.text}}
      </div>
      </template>
    </notifications>

      <notifications group="custom-error" position="top right">
        <template slot="body" slot-scope="props">
          <div class="alert alert-warning mb-2">
          <a class="close" @click="props.close"><i class="icon-cross"></i></a>
          <strong>{{props.item.title}}</strong>
          <br>{{props.item.text}}
        </div>
        </template>
      </notifications>

  </div>
</template>

<script>
import Loader from "./components/Loader.vue";

export default {
  name: 'App',
  data () {
    return {}
  },
  components: {
    Loader,
  },
  created() {
    
  },
  methods:{
    
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue